module.exports = __webpack_public_path__ + "static/media/Aeonik-Bold.3ab5a630.otf";